import EventBus from '@/event-bus'

export default {
  handle(data) {
    console.log(data)
    EventBus.$emit('status-updated', data.permission)
  },
}
